import { partial } from 'lodash';
import { Map, Set } from 'immutable';
import { useReducer, useMemo } from 'react';

function reducer(state, action) {
  switch (action.type) {
    case 'check':
      return state.withMutations((state) => {
        state.setIn(['items', action.payload.id], true);
        state.update('checked', (checked) => checked.add(action.payload.id));

        return state;
      });
    case 'uncheck':
      return state.withMutations((state) => {
        state.setIn(['items', action.payload.id], false);
        state.update('checked', (checked) => checked.delete(action.payload.id));

        return state;
      });
    case 'uncheckAll':
      return state.withMutations((state) => {
        state.set('items', Map());
        state.set('checked', Set());

        return state;
      });
    case 'checkMany':
      return state.withMutations((state) => {
        for (const id of action.payload.ids) {
          state.setIn(['items', id], true);
          state.update('checked', (checked) => checked.add(id));
        }

        return state;
      });
    default:
      return state;
  }
}

function check(state, dispatch, id) {
  const action = {
    type: 'check',
    payload: {
      id,
    },
  };

  dispatch(action);
}

function uncheck(state, dispatch, id) {
  const action = {
    type: 'uncheck',
    payload: {
      id,
    },
  };

  dispatch(action);
}

function uncheckAll(state, dispatch) {
  const action = {
    type: 'uncheckAll',
  };

  dispatch(action);
}

function checkMany(state, dispatch, ids) {
  const action = {
    type: 'checkMany',
    payload: {
      ids,
    },
  };

  dispatch(action);
}

function getAll(state) {
  return state.get('checked').toArray();
}

function isChecked(state, dispatch, id) {
  return state.getIn(['items', id], false) === true;
}

function any(state) {
  return !state.get('checked').isEmpty();
}

function count(state) {
  return state.get('checked').count();
}

function bindMethods(methods, state, dispatch) {
  for (const method of Object.keys(methods)) {
    if (typeof methods[method] === 'function') {
      methods[method] = partial(methods[method], state, dispatch);
    }
  }

  return methods;
}

function getDefaultState() {
  return Map({
    items: Map(),
    checked: Set(),
  });
}

export default function useChecklist() {
  const [state, dispatch] = useReducer(reducer, getDefaultState());

  const methods = useMemo(
    () =>
      bindMethods(
        {
          check,
          checkMany,

          uncheck,
          uncheckAll,

          isChecked,
          any,
          count,

          getAll,
        },
        state,
        dispatch
      ),
    [state]
  );

  const data = {
    any: useMemo(() => methods.any(), [state]),
    count: useMemo(() => methods.count(), [state]),
    checked: useMemo(() => methods.getAll(), [state]),
  };

  return {
    data,
    ...methods,
  };
}
